import { render, staticRenderFns } from "./noResultFound.vue?vue&type=template&id=5ff44d0b&scoped=true&"
import script from "./noResultFound.vue?vue&type=script&lang=js&"
export * from "./noResultFound.vue?vue&type=script&lang=js&"
import style0 from "./noResultFound.vue?vue&type=style&index=0&id=5ff44d0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff44d0b",
  null
  
)

export default component.exports